const Form047TC = {
    stepName: {
        importantNotes: "重要事項",
        personalInfo: "個人資料",
        workExperience: "工作經驗",
        confirmation: "確認",
    },
    statementHeader: "填表須知",
    statementContent:
        "你幼兒中心的名稱、地址、註冊日期和你的姓名將根據幼兒服務條例第8條給公眾人士查閱﹐以證實你的幼兒中心已依上述法例規定的規定註冊。",
    importantNotes: {
        importantNote:"沒有「智方便+」戶口的申請人須把已填妥的申請表交回幼稚園及幼兒中心聯合辦事處處理（地址：香港太古城太古灣道14號6樓602室）。請確保已為郵件支付足夠郵資，以免未能送達本局。郵資不足的郵件，一律會由香港郵政處理。",

        title: "個人資料收集聲明",
        p_title: "收集個人資料的目的",
        p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        p1_a: "就幼兒中心經營人申請中心註冊，辦理有關處理、核實及查證的事務；",
        p1_b: "就上文(a)項所述的處理、核實及查證，辦理有關把個人資料與政府相關政策局／部門資料庫進行核對程序的事務；",
        p1_c: "為核實／更新教育局的記錄，辦理有關把個人資料與教育局資料庫進行核對程序的事務；",
        p1_d: "辦理有關培訓及發展的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        p1_e: "辦理有關處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計的事務；",
        p1_f: "辦理有關編製統計資料、研究材料及政府刊物的事務，以及",
        p1_g: "辦理有關施行及強制執行規則及規例 [包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]的事務；及《幼兒服務條例》(香港法例第243章)及其附屬法例 [即《幼兒服務規例》(香港法例第243A章)]的事務",

        p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。",

        p_title3: "可獲轉移資料者",
        p3_1: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        p3_a: "政府其他政策局及部門，包括社會福利署 ，城市規劃委員會、地政總署、消防處、屋宇署或建築署，機電工程署，學生資助辦事處以用於上文第1段所述的用途；",
        p3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
        p3_c: "受聘於教育局以提供服務或意見的人員、代理人、服務供應商；及/或其他有關個人/機構 (例如:物業持有人或房屋委員會)以用於上文第1段所述的用途；",
        p3_d: "你曾就披露個人資料給予訂明同意；以及",
        p3_e: "根據適用於香港的法例或法庭命令授權或規定披露個人資料，包括將根據幼兒服務條例第8條給公眾人士查閱，以證實你的幼兒中心已依上述法例規定的規定註冊。",

        p_title4: "查閱個人資料",
        p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 <a href='mailto: jokc@edb.gov.hk'>jokc@edb.gov.hk</a>。",
        // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },
    label: {
        header: "重要事項",
        note: {
            // note: "注意：",
            note1: "你在本表格所提供的資料將供本辦事處為你的幼兒中心作註冊之用﹐本辦事處亦可能會向有需要知道這些資料的有關部門透露。你幼兒中心的名稱、地址、註冊日期和你的姓名將根據幼兒服務條例第8條給公眾人士查閱﹐以證實你的幼兒中心已依上述法例規定的規定註冊。",
        },
        statement: "本人已閱讀、明白及同意上述條款及細則。",
        iamStatement:
            "本人理解申請人和學校審批人需要擁有「智方便+」帳戶才能處理申請。",
        titleOption: {
            Mr: "先生",
            Mrs: "夫人",
            Miss: "小姐",
            Ms: "女士",
        },
        qualificationOption: {
            P: "小學",
            S: "中學",
            postSecondary: "專上",
            T: "大學",
            others: "其他",
        },
        childCareTrainingOption: {
            yes: "有，請說明",
            no: "無",
        },
        childCareExperienceOption: {
            yes: "有，請列明如下",
            no: "無",
        },
        ownershipOfChildCareCentreOption: {
            yes: "有，請列明如下",
            no: "無",
        },
        choose: "香港身份證號碼／護照號碼",
        chooseOption: {
            hkid: "香港身份證號碼",
            passport: "護照號碼",
        },
        personalInfo: "個人資料",
        workExperience: "工作經驗",
        confirmation: "確認",
        nomineeTitle: "稱謂",
        englishName: "英文姓名",
        chineseName: "中文姓名",
        dateOfBirth: "出生日期",
        // year: "年",
        // mon: "月",
        // day: "日",
        nationality: "國籍",
        residentialAddress: "住址",
        specify: "請註明：",
        tel: "電話號碼",
        fax: "傳真號碼",
        sameAsAddress: "通訊資料同上",
        yes: "是",
        no: "否",
        correspondenceAddress: "通訊地址",
        tel1: "電話號碼",
        fax1: "傳真號碼",
        presentOccupation: "目前職業",
        qualification: "學歷",
        required: "必須提供",
        // 第二頁的title
        childCareTraining: "幼兒工作訓練",
        nameOfInstitute: "學院名稱",
        courseName: "課程名稱 （依畢業證書寫法）",
        yearOfAward: "修畢年份",
        childCareExperience: "幼兒工作經驗（請包括現時工作）",
        nameOfChildCareCentre: "幼兒中心／機構名稱",
        position: "職位",
        ageRangeOfChildrenServed: "所服務兒童的年齡組別",
        dateOfCommencement: "到職日期",
        leaving: "已離職",
        leavingOption: {
            yes: "是",
            no: "否",
        },
        dateOfLeaving: "離職日期",

        ageRangeOfChildrenServed2: "",

        ownershipOfChildCareCentre: "經營幼兒中心資料",
        nameOfCentre: "中心名稱",
        periodOfOwnership: "經營時間",
        nautreOfOwnership: "經營形式",
        nautreOfOwnershipOption: {
            sole: "全部",
            shared: "部分",
        },
        year: "例如：“2-3” 為二至三歲",
    },
    errorMsg: {
        chineseName: "請輸入一個有效的中文姓名",
        englishName: "請輸入一個有效的英文姓名",
        passport: "請輸入一個有效的護照號碼",
        nationality: "請輸入一個有效的國籍",
        instituteName: "請輸入一個有效的學院名稱",
        courseName: "請輸入一個有效的課程名稱",
        childCareCentre: "請輸入一個有效的幼兒中心／機構名稱",
        centreName: "請輸入一個有效的中心名稱",
        ownership: "請輸入一個有效的經營時間",
        range: "請輸入一個有效的範圍（e.g. “2-3”）",
        residentialAddress: "請輸入一個有效的住址",
        correspondenceAddress: "請輸入一個有效的通訊地址",
        presentOccupation: "請輸入一個有效的目前職業",
        otherQualification: "請輸入一個有效的學歷",
        position: "請輸入一個有效的職位",
        tel: "請輸入至少一個電話號碼。",
        E001: "不允许使用数字",
        E002: "只能是字母",
        E003: "字母數字或者中文數字",
        E004: "匹配身份證號碼规则（默認: XX999999(X)）",
        E005: "匹配护照规则（默认最大长度10，字符类型字母-数字）",
        code: "請輸入一個有效的區號",
    },
};
export default Form047TC;
